var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"field",attrs:{"type":"email","name":"email","autocapitalize":"none","rules":[_vm.required, _vm.emailed],"label":_vm.$t('users.form.email')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})
}
var staticRenderFns = []

export { render, staticRenderFns }